module.exports = function() {
  return new Worker(__webpack_public_path__ + "5e6276790dafca99bb43.worker.js");
};